<script>
    
            
    import { createEventDispatcher } from 'svelte';
    /**
     * @typedef {Object} Props
     * @property {any} name
     * @property {any} value
     * @property {any} [options]
     * @property {boolean} [required]
     * @property {any} associatedID
     */
    let {
        name,
        value = $bindable(),
        options = [],
        required = false,
        associatedID = null,
        onchange = () => {}
    } = $props();


    const dispatch = createEventDispatcher();

    let input = $state(null);

    function handleClick(e) {
        value = e.target.dataset.name;
        input.value = value;

        onchange({
            detail: {
                originalEvent: e,
                name,
                value,
                associatedID
            }
        });
        
    }

    // Expose editorDOM for testing
    export function getEditorDOM() {
        return input;
    }
</script>

<div class="input">
    <input bind:this={input} type="radio" {name} {value} style="display:none;" {required}>
    <fieldset>
        {#key value}
            {#each options as o}
                <p class="row">
                    <!-- svelte-ignore a11y_click_events_have_key_events -->
                    <i onclick={handleClick} data-name={o.name} class="material-icons interactive checkbox-icon {value === o.name ? 'checked' : ''}">{value === o.name ? 'radio_button_checked' : 'radio_button_unchecked'}</i>
                    <span class="label">{o.displayName}</span>
                </p>
            {/each}
        {/key}
    </fieldset>
</div>

<style>

    .input{
        display:flex;
    }

    .input fieldset{
        display:flex;
        flex-direction: column;
    }

    .row{
        display:flex;
        align-items: center;
    }

    .row:not(:last-of-type){
        margin-bottom:0.5rem;
    }


    input[type='radio']{
        width:1.2rem;
        height:1.2rem;
        border:none;
        outline:none;
        margin:0 0.75rem 0 0.125rem;
        
    }

    .checkbox-icon{
        margin-right:0.5rem;
    }

    .checkbox-icon.checked{
        color:rgb(74, 198, 255);
    }

    .label{
        display:flex;
        align-items:center;
        text-transform: uppercase;
        font-weight:600;
        font-size:0.75rem;
        margin-left:0.25rem;
        color:rgba(255, 255, 255, 0.6);
    }
</style>

